import { useContext, useEffect, useState } from "react";
import { GetUserQuery, useGetUserQuery } from "../graphql/types";
import { UserTypeContext } from "../contexts/UserTypeContext";
import { fetchAuthSession } from "aws-amplify/auth";

const useGetChamberFromUserIdInAuth = ():
  | GetUserQuery["getUser"]["chamberInfo"]
  | undefined => {
  const [cognitoSub, setCognitoSub] = useState<string | undefined>(undefined);
  useEffect(() => {
    const main = async (): Promise<void> => {
      const authSession = await fetchAuthSession();
      setCognitoSub(authSession?.tokens?.idToken?.payload?.sub);
    };
    main();
  }, []);

  const {
    state: { userType },
  } = useContext(UserTypeContext);

  const { data } = useGetUserQuery({
    variables: { userId: cognitoSub || "" },
    skip: !cognitoSub || !userType, // need to check for empty string here because its set to empty string at logout... and this query shouldn't run while its empty string
  });

  return data?.getUser?.chamberInfo;
};

export default useGetChamberFromUserIdInAuth;
